import { useDeveloperSettingsStore } from '@/store';
import { messages } from '@/i18n';

import type { default as AxiosMockAdapter } from 'axios-mock-adapter';
import type { PluginPackageInitializeModuleOptions } from 'commercial-web-client-utilities/dist/types/common';

export default function(options: PluginPackageInitializeModuleOptions) {
    const developerSettingsStore = useDeveloperSettingsStore();

    const {
        i18n,
        authenticationServiceMockAdapter,
        commwebServiceMockAdapter,
        ledsServiceMockAdapter,
        nonsecureServiceMockAdapter
    } = options;

    for (const locale in messages) {
        i18n.global.mergeLocaleMessage(locale, messages[locale as keyof typeof messages]);
    }

    return (async () => {
        // Use Axios Mock Adapter if enabled.
        if (developerSettingsStore.serviceTestDataScenario !== null) {
            let applyMocks: (mockAdapter: AxiosMockAdapter) => void;
            try {
                applyMocks = (await import(`@/mock/service/default${
                    developerSettingsStore.serviceTestDataScenario
                }`)).applyMocks;
            } catch (error) {
                applyMocks = (await import('@/mock/service/default')).applyMocks;
            }
            authenticationServiceMockAdapter && applyMocks(authenticationServiceMockAdapter);
            commwebServiceMockAdapter && applyMocks(commwebServiceMockAdapter);
            ledsServiceMockAdapter && applyMocks(ledsServiceMockAdapter);
            nonsecureServiceMockAdapter && applyMocks(nonsecureServiceMockAdapter);
        }
    })();
}